import { render, staticRenderFns } from "./TableSenderInfo.vue?vue&type=template&id=27c90a54&"
import script from "./TableSenderInfo.vue?vue&type=script&lang=js&"
export * from "./TableSenderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports